import * as React from "react";
import styled from "styled-components";

import { LoadingSpinner } from "../LoadingSpinner";

interface IProps {
  loading: boolean;
  loadingText: string;
}

const TableLoadingStyled = styled.div`
  transition: ${({ theme }) => theme.transition.quicker};
  opacity: 1 !important;
  position: absolute;
  z-index: 99;
  top: 90px;
  left: 0;
  width: 100%;
  height: calc(100% - 90px);

  * {
    box-sizing: content-box !important;
  }

  > div {
    position: relative;
    z-index: 2;

    > div {
      transition: ${({ theme }) => theme.transition.quicker};
      top: 0;
    }
  }
`;

const TableLoading = ({ loading }: IProps) => {
  // Return null if loading is false
  if (!loading) {
    return null;
  }

  return (
    <TableLoadingStyled className="rt-loading">
      <LoadingSpinner type="circular" />
    </TableLoadingStyled>
  );
};

export default TableLoading;
